import LayoutPage from '@/components(new)/layout/LayoutBases/LayoutAnalise/LayoutAnalise.vue'
import menuOptions from '@/libs/constants/painel/certificacao/menu.js'
import { items } from './routes'

const cadastro = [
  {
    path: '/certificacao',
    name: 'certificacao',
    component: LayoutPage,
    props: {
      menuOptions: menuOptions
    },
    redirect: '/certificacao/caixa-entrada',
    children: [...items]
  }
]

export default cadastro



// WEBPACK FOOTER //
// ./src/router/certificacao/index.js